import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import {
  OrchSurveyRequest,
  QineticSurveyApi,
} from "../../orchestrator-api-client";
import { SurveyCodeEnum } from "../../enums/survey-code.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitAdvData = createAsyncThunk<
  Record<string, string>,
  Record<string, string>,
  ThunkApi
>("submitAdvData", async (args, { rejectWithValue, getState }) => {
  try {
    const {
      customer: {
        personalInfo: { fiscalCode },
      },
    } = getState();

    const arrayAdv = Object.entries(args).map(([key, value]) => ({
      surveyQuestion: key,
      surveyAnswer:
        typeof value === "object" && value !== null
          ? (value as { label: string; value: string }).value
          : value,
    }));

    const surveyPayload: OrchSurveyRequest = {
      surveyRequests: arrayAdv,
    };
    await new QineticSurveyApi().sendSurvey(
      fiscalCode,
      SurveyCodeEnum.ADEG_VER,
      surveyPayload,
    );
    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio adv",
      description:
        "Non siamo riusciti a salvare le tue domande.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
